import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { deleteSite } from 'action/site'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'

const FALLBACK_ERROR = 'Please try again'

const generateModalText = (name) => ({
  decide: {
    content: 'This action cannot be undone',
    title: `Are you sure you want to delete ${name}?`
  },
  outcome: {
    content: {
      error: (error) => error?.message || FALLBACK_ERROR,
      success: `${name} has been successfully deleted.`
    },
    title: {
      error: `There has been an issue deleting ${name}`,
      success: 'Site deleted'
    }
  }
})

const DeleteSite = ({ deleteSite, site: { uuid, site_name: name } }) => {
  const { decide, outcome } = generateModalText(name)
  const handleSubmit = async () => {
    const response = await deleteSite(uuid)

    if (response?.error) {
      throw new Error(response.message)
    }
  }
  const handleClick = () => confirmModal(handleSubmit, decide, outcome)

  return <a onClick={handleClick}>Delete Site</a>
}

DeleteSite.propTypes = {
  deleteSite: PropTypes.func,
  site: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  deleteSite: bindActionCreators(deleteSite, dispatch)
})

export default connect(null, mapDispatchToProps)(DeleteSite)
